import * as React from 'react';
import { useFragment } from 'react-relay';

import { ExcelExport } from '@components/excelExport';
import * as moment from 'moment';
import { XDomain } from '../../widgets/performanceOverview';

import { performanceOverviewMenuFragment } from './PerformanceOverviewMenu.relay';
import type { PerformanceOverviewMenuPropsType } from './types';

const buildExcelFileName = (isin: string, detailXDomain: XDomain) => {
    let fileName = `performance_${isin}`;
    const start = moment(detailXDomain[0]);
    const end = moment(detailXDomain[1]);
    if (start.isValid() && end.isValid()) {
        fileName = `performance_${start.format('YYYYMMDD')}_${end.format('YYYYMMDD')}_${isin}`;
    }

    return fileName;
};

const PerformanceOverviewMenu: React.FC<PerformanceOverviewMenuPropsType> = (props) => {
    const menu = useFragment(performanceOverviewMenuFragment, props.menu);

    if (!menu) {
        return null;
    }

    return (
        <ul
            className={`PerformanceOverview-menu absolute right-0 top-8 h-full max-h-[380px] w-[29%] max-w-[250px] list-none border-l-[5px] border-l-[rgba(230,230,230,0.95)] bg-[rgba(250,250,250,0.95)] pt-5 transition-transform duration-500 ease-in-out max-[1100px]:w-1/2 max-[550px]:max-h-none max-[550px]:w-[80%] ${props.isVisible ? 'translate-x-0' : 'translate-x-[110%]'} [&_.PerformanceOverview-menuitem]:ml-[10%] [&_.PerformanceOverview-menuitem]:inline-block [&_.PerformanceOverview-menuitem]:cursor-pointer [&_.PerformanceOverview-menuitem]:bg-position-[left_center] [&_.PerformanceOverview-menuitem]:bg-no-repeat [&_.PerformanceOverview-menuitem]:bg-size-[25px_25px] [&_.PerformanceOverview-menuitem]:py-2.5 [&_.PerformanceOverview-menuitem]:pl-10 [&_.PerformanceOverview-menuitem]:pr-2.5 [&_.PerformanceOverview-menuitem]:text-black [&_.PerformanceOverview-menuitem]:no-underline [&_.PerformanceOverview-menuitem_a]:text-black [&_.PerformanceOverview-menuitem_a]:no-underline`}
        >
            <li className='PerformanceOverview-menuitem PerformanceOverview-menuitem-xls bg-[url(/static/front/assets/other-icons/download4x.png)]'>
                <ExcelExport
                    linkText={menu.xlsdownloadtext}
                    xDomain={props.detailXDomain}
                    hasBenchmark={props.hasBenchmark}
                    data={props.preparedData}
                    colWidth={[11, 10]}
                    fileName={buildExcelFileName(props.isin, props.detailXDomain)}
                    sheetName={props.isin}
                    useColumns={['date', 'performance']}
                    reportCurrency={props.reportCurrency}
                    disclaimer={props.disclaimer}
                    useLocale={props.language}
                />
            </li>
            <li
                className='PerformanceOverview-menuitem PerformanceOverview-menuitem-currency bg-[url(/static/front/assets/other-icons/money.png)]'
                onClick={props.openCurrencySelection}
            >
                {menu.currencySelectionHeader}
            </li>
        </ul>
    );
};

export { PerformanceOverviewMenu };
